




















































































































/** @format */

import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import moment from 'moment';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { CHARGING_BRAND_MANAGEMENT } from '../router-names';
// axios请求
import {
  chargingPileList,
  chargingPileDetail,
  chargingPileEditStatus,
  chargingList,
  chargingPileBrand
} from '@/api/chargingpile-management/index';
import Utils from '@root/utils/common';
// 字典
import { chargingpileStatusMap, allowCumsumMap, allowTypeMap } from '@/types/chargingpile-management/dictionaries';
import OrganizationSearch from '@/components/organization-search/index.vue';
import * as _ from 'lodash';
import AddEditModal from './components/addEdit.vue';
@Component({
  name: 'ChargerecordList',
  components: {
    ParkingLotSearch,
    OrganizationSearch,
    AddEditModal
  }
})
// @Component
export default class DeviceOperation extends Mixins(TableMixin, TableWidthMixin) {
  statusOptions: IOption[] = _.concat([{ label: '全部', value: '' }], Utils.toLabelVal(chargingpileStatusMap));
  allowCumsumOptions: IOption[] = Utils.toLabelVal(allowCumsumMap);
  discountTypeOptions: IOption[] = Utils.toLabelVal(allowTypeMap);

  //搜索参数
  private filterParam: any = {
    orgdepId: '',
    status: '',
    allowCumsum: '',
    parkId: [],
    pkBrandId: '',
    ruleName: ''
  };
  tableLoading = false;
  tableData: any[] = []; // 表数据
  disableFlag: boolean = false;
  //搜索时间配置
  private onTimeChange(date: any, dateString: any) {
    let [operateTimeStart, operateTimeEnd] = dateString;
    this.filterParam.startDate = operateTimeStart;
    this.filterParam.endDate = operateTimeEnd;
  }
  get defaultTime() {
    if (this.filterParam.startDate && this.filterParam.endDate) {
      return [
        this.moment(this.filterParam.startDate, 'YYYY-MM-DD'),
        this.moment(this.filterParam.endDate, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.startDate) {
      return [this.moment(this.filterParam.startDate, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  private moment = moment;
  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  activated() {
    // console.log('000,wo lai le ');
    this.getChargingList();
  }
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '所属机构',
        dataIndex: 'orgdepName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '充电品牌',
        dataIndex: 'brandName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '优惠名称',
        dataIndex: 'discountName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '优惠类型',
        dataIndex: 'discountType',
        width: 200,
        scopedSlots: { customRender: 'discountType' }
      },
      {
        title: '优惠数额',
        dataIndex: 'discountValue',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '最低充电时长（分钟）',
        dataIndex: 'miniChargedTime',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '多次充电优惠是否累加',
        dataIndex: 'allowCumsum',
        width: 180,
        customRender: (text: any) => (text == '00' ? '是' : '否' || '--')
      },
      {
        title: '单次停车可优惠次数',
        dataIndex: 'discountLimit',
        width: 180,
        customRender: (text: any) => (text === '999' ? '不限制' : text || '--')
      },
      {
        title: '状态',
        dataIndex: 'status',
        width: 100,
        scopedSlots: { customRender: 'status' }
      },
      // {
      //   title: '充电品牌ID',
      //   dataIndex: 'brandId',
      //   width: 260,
      //   scopedSlots: { customRender: 'text-ellipse-to-tip' }
      // },
      {
        title: '操作人',
        dataIndex: 'operator',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '操作时间',
        dataIndex: 'operateTime',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 140,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  brandList: any[] = [];
  editModel: boolean = false; //弹出框是否显示
  isEdit: boolean = false;
  addEditModalData: any = null;
  // 生命周期初始化表单列表
  created() {
    this.fetchTableData();
    this.getChargingList();
  }
  mounted() {
    this.getChargingList();
  }
  //获取充电品牌列表
  async getChargingList() {
    try {
      const res = await chargingPileBrand({});
      this.brandList = res.data.map(item => {
        return { label: item.brandName, value: item.pkChargeBrandId };
      });
      // this.filterParam.brandId = ''
    } catch (e) {
      this.$message.error((e && e.msg) || '系统异常请稍后再试');
    }
  }
  filterOption(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  //   去编辑
  async editItem(val?: any) {
    if (val) {
      this.isEdit = true;
      try {
        // const { data } = await chargingPileDetail({ brandId: val.brandId })
        // this.addEditModalData = data ? data : {}
        this.addEditModalData = Object.assign({}, val);
        if (val && val.discountType == '00') {
          //时长
          this.addEditModalData.discountValue = val.discountValue
            ? val.discountValue.substring(0, val.discountValue.length - 2)
            : '';
        } else {
          this.addEditModalData.discountValue = val.discountValue
            ? val.discountValue.substring(0, val.discountValue.length - 1)
            : '';
        }
      } catch (error) {
        return this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      }
    } else {
      this.isEdit = false;
    }
    this.editModel = true;
  }
  //   启用禁用
  isforbiddenChange() {}
  /**
   * 请求数据列表
   */
  current = 1;
  pageSize = 10;
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { parkId, ...rest } = this.filterParam;
      const { status, code, msg, data } = await chargingPileList({
        ...rest,
        parkId: parkId.join(','),
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空table
  onTableFilterClear({ defaultParkIdList }) {
    this.filterParam = {
      orgdepId: '',
      brandName: '',
      status: '',
      allowCumsum: '',
      parkId: defaultParkIdList
    };
    this.searchTable();
  }
  toChargingBrand() {
    this.$router.push({
      name: CHARGING_BRAND_MANAGEMENT
    });
  }
  //弹窗取消
  handleModalCancel() {
    this.editModel = false;
  }
  //弹窗保存
  handleModalCreate() {
    this.editModel = false;
    this.fetchTableData(true);
  }
  //启用停用
  disableItem(val: any) {
    let that = this;
    this.$confirm({
      title: val.status === '00' ? '停用' : '启用',
      content: `${
        val.status === '00' ? '停用后无法发放充电优惠，确定要停用吗？' : '启用后可正常发放充电优惠，确定要启用吗？'
      }`,
      async onOk() {
        if (that.disableFlag) return;
        that.disableFlag = true;
        try {
          await chargingPileEditStatus({
            parkId: val.parkId,
            brandId: val.brandId,
            pkBrandRuleId: val.brandRuleId,
            status: val.status == '00' ? '01' : '00'
          });
          that.$message.success(val.status == '00' ? '停用成功' : '启用成功');
          that.fetchTableData();
        } catch (e) {
          console.log('报错了', e, e.msg);
          that.$message.error((e && e.msg) || (val.status == '00' ? '停用失败' : '启用失败'));
        } finally {
          that.disableFlag = false;
        }
      },
      cancelText: '取消',
      onCancel() {
        that.disableFlag = false;
      }
    });
  }
  //获取优惠类型
  getTypeName(value) {
    let a = [];
    if (value) {
      a = _.filter(this.discountTypeOptions, function(o) {
        return o.value == value;
      });
      return a.length > 0 ? a[0].label : '--' || '--';
    }
    return '--';
  }
  //获取状态 statusOptions
  getStatusName(value) {
    let a = [];
    if (value) {
      a = _.filter(this.statusOptions, function(o) {
        return o.value == value;
      });
      return a.length > 0 ? a[0].label : '--' || '--';
    }
    return '--';
  }
}
